import {valueSchema, answerSchema} from './schema.js'
import {validate} from '../../../lib/schema-validator.js'

export const DATA_POINT_ID = 'are_there_written_recs_of_these_cases_9'

export const dataPointDefinition = {
  retracedId: 'are_there_written_recs_of_these_cases_9',
  name: 'Are there written records of these cases?',
  description:
    'The intent of the question is to determine if, upon receipt of complaint of harassment:\r\r\n• the dates, times and facts of the incident(s) were immediately recorded\r\r\n• the views of the victim as to what outcome he/she wants were ascertained\r\r\n• the victim understood the company’s procedures for dealing with the complaint\r\r\n• Next steps were discussed and agreed: either informal or formal complaint, on the understanding that choosing to resolve the matter informally does not preclude the victim from pursuing a formal complaint if he/she is not satisfied with the outcome\r\r\n• records of all discussions have been kept confidentially \r\r\n• the rights of the victim have been respected\r\r\n• the victim is aware of her/his right to lodge the complaint outside of the company through the relevant country/legal framework',
  meta: {},
  fieldTypeId: 'YES_NO',
  type: 'RELATIONAL',
  options: [
    {
      name: 'Yes',
      key: 'YES',
      slcpIndex: 1,
      slcpOptionName: 'yes-no',
    },
    {
      name: 'No',
      key: 'NO',
      slcpIndex: 2,
      slcpOptionName: 'yes-no',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
        enum: ['YES', 'NO'],
      },
    },
    required: ['value'],
  },
  externalIds: [
    {
      id: 'wt-har-18',
      version: '1.5.0',
      provider: 'slcp',
    },
  ],
  sortingId: 10560,
  sectionId: '2.2.5.5',
  impactArea: 'Harassment and Abuse',
  impactAreaId: 'HARRASSMENT_AND_ABUSE',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}

export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`${DATA_POINT_ID}: ${error}`)
  }
}
